var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "evenodd",
    d: "M15.924 4.418a23.8 23.8 0 0 0-7.848 0a1.19 1.19 0 0 0-.973.94a35.6 35.6 0 0 0-.142 13.327l.163.913l3.67-3.487a1.75 1.75 0 0 1 2.411 0l3.67 3.487l.164-.913a35.6 35.6 0 0 0-.142-13.327a1.19 1.19 0 0 0-.973-.94M7.828 2.94a25.3 25.3 0 0 1 8.344 0a2.69 2.69 0 0 1 2.195 2.123c.923 4.579.973 9.29.149 13.888l-.222 1.235a1.323 1.323 0 0 1-2.213.726l-3.909-3.713a.25.25 0 0 0-.344 0l-3.909 3.713a1.323 1.323 0 0 1-2.213-.726l-.222-1.235a37.1 37.1 0 0 1 .148-13.888A2.69 2.69 0 0 1 7.828 2.94",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistLogo);
export default __webpack_public_path__ + "static/media/wishlistLogo.94822a269ef551b77c37c11416ec5fdf.svg";
export { ForwardRef as ReactComponent };